import { render } from "./IndividualCustomer.vue?vue&type=template&id=2682e1b2&scoped=true&ts=true"
import script from "./IndividualCustomer.vue?vue&type=script&lang=ts"
export * from "./IndividualCustomer.vue?vue&type=script&lang=ts"

import "./IndividualCustomer.vue?vue&type=style&index=0&id=2682e1b2&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2682e1b2"]])

export default __exports__